module.exports = __webpack_public_path__ + "media/images/category_icons/chant-093c3391a109287cac35c82e8fe0e8c5.svg";